import React from 'react';
import cl from './FormControlCaption.module.css';
import InlineTip from "../components/InlineTip";
import {inlineTipMargin} from "../AppVars";

const FormControlCaption = ({text, tipText}) => {
    if (!text)
        return null;

    return (
        <div className={cl.main}>
            {text}
            {tipText && <InlineTip text={tipText} style={{marginLeft:`${inlineTipMargin}px`}}/>}
        </div>
    );
};

export default FormControlCaption;